import React from 'react';

import { PipeOutput } from '../../../components/pipe-output/PipeOutput.container';

import type { RouteComponentProps } from 'react-router';
import type { FlowInputOutput } from '../../../types/flows.types';

export const FlowOutputPage: React.FC<
  RouteComponentProps<{}, any> & { flow: FlowInputOutput[] }
> = ({ flow, params }) => {
  const { subId } = params;
  const lastPipe = flow[flow.length - 1]?.data;

  return <PipeOutput inputPipe={lastPipe} subId={subId} />;
};
